export default __webpack_public_path__ + "static/media/ic_list_bulleted.04f0368d.svg";